import React from 'react';
import './coder-queue-count.scss';

export interface CoderQueueCountProps {
  count: number;
  context: 'assigned' | 'available';
}

export const CoderQueueCount: React.FC<CoderQueueCountProps> = ({
  count
}) => {
  // Both assigned and available coders show their total assigned-queue count. (The `context` prop is
  // retained on the interface for styling/back-compat but no longer drives the wording.)
  const label = `Assigned to ${count} queue${count === 1 ? '' : 's'}`;

  return <span className="cmx-coder-queue-count">{label}</span>;
};

CoderQueueCount.displayName = 'CoderQueueCount';
